import EventBus from '../services/event-bus';
import { EVENTS, base_url, base_img, PRODUCT_TYPES } from './constants';
import moment from 'moment';
import _ from 'lodash';
import ClientService from '../services/client-service';
import UserService from '../services/user-service';
import ShopService from '../services/shop-service';
import DataStore from './data-store';
import growl from './growl';
import UiServiceDelegate from '../services/ui-service-delegate';
import UrlService from '../services/url-service';
import Cookies from 'js-cookie';
import OptionCategoryService from '../services/option-category-service';
import { CartItem, Order, Shop } from '../../types';
import UpsellService from './UpsellService';
import OrderCalc from '../checkout/order-calc-service';

// : { cart: Order, [key: string]: any }
let factory = {
	cart: null,
	nbArticles,
	orderToJson,
	changeCartShop,
	SALE_AREA_NAMES: {
		1: 'Restaurant',
		2: 'Sur place',
		3: 'A emporter',
		4: 'Livraison',
	},
	OrderStateNames: {
		'-5': 'Paiement partiel',
		'-4': 'En attente de confirmation du paiement',
		'-3': 'Expiré',
		'-2': 'Modifiable',
		'-1': 'Non confirmé',
		0: 'En attente',
		1: 'Confirmé',
		2: 'Annulé',
		3: 'Chargeback',
	},
	ORDER_STATES: {
		STATE_PARTIAL_PAYMENT: -5,
		STATE_PENDING_PAYMENT_CONFIRMATION: -4,
		STATE_EXPIRED: -3,
		STATE_MODIFIABLE: -2,
		STATE_VALIDATED_UNCONFIRMED: -1,
		STATE_CONFIRMED: 0,
		STATE_DELIVERED: 1,
		STATE_CANCELLED: 2,
		STATE_CHARGEBACK: 3,
	},
	PAYMENT_STATES: {
		PAYMENT_NOT_STARTED : 'PAYMENT_NOT_STARTED',
		PAYMENT_PENDING : 'PAYMENT_PENDING',
		PAYMENT_FORWARDING : 'PAYMENT_FORWARDING',
		PAYMENT_AUTHORIZED : 'PAYMENT_AUTHORIZED',
		PAYMENT_CANCELLED : 'PAYMENT_CANCELLED',
		PAYMENT_CAPTURED : 'PAYMENT_CAPTURED',
		PAYMENT_REFUSED : 'PAYMENT_REFUSED',
		PAYMENT_ERROR : 'PAYMENT_ERROR',
	},
	backendToCart,
	newCart,
	emptyCart,
	getDetails,
	saveCart,
	addToCart,
	canOrder,
	getExistingItem,
	itemTotal,
	categoryTotal,
	cartTotal,
	removeFromCart,
	increaseItemQty,
	decreaseItemQty,
	itemToCartItem,
	sumWeightAllOptionsTaken,
	getOptionCart,
	setRestoMode,
	isRestoMode,
	deleteRestoMode,
	setClientForOrder,
	getDisplayItems,
	getPrice,
	checkOrder,
	save: {
		processing: false,
	},
	reorder,
	printCurrentOrder,
	getUpselledItemName,
};
export default factory;

init();


function printCurrentOrder() {
	let head_links = '<link rel="stylesheet" href="'+UrlService.getBasePath()+'dist/commons~admin~app.css">'
	+ '<link rel="stylesheet" href="'+UrlService.getBasePath()+'dist/commons~admin~app~map.css">'
	+ '<link rel="stylesheet" href="'+UrlService.getBasePath()+'dist/commons~admin~app~map.css">'
	var w = window.open();
	var html = $("order-details").html();
	$(w.document.body).html(html);
	$(w.document.body).append(head_links);
	w.close();
	$(w.document.body).append('<script>window.print()</script>');
}

function reorder(order) {
	ShopService.setShopIdAsync(order.ShopId)
	.then((shop) => getDetails(order.OrderId, true))
	.then((order2) => {
		emptyCart(true);
		// delete unique quote data
		delete order.info2.docusign_envelope_id;
		delete order.info2.hostedRegister;
		factory.cart.info2 = order2.info2;
		for(let i in order2.oi) {
			let item = order2.oi[i];
			item = refreshPrice(item, 0, order2.shop, false);
			// no item: item not available at this time (out of stock)
			if (item) {
				addToCart(factory.cart, item);
			}
		}
		if (factory.cart.oi.length) {
			UrlService.go({name:'carte',params:{ShopId: order2.ShopId, tid: 0}},() => UiServiceDelegate.toggleCart(true))
		} else {
			growl.warning("Aucun produit disponible");
		}
	})
}

function nbArticles() {
	return factory.cart && _.sumBy(factory.cart.oi,'qty');
}

// joinPrices indicates that we're in a menu
// in a menu, by default (no joinPrices[fId] :
// - regular products (ty == 3) are included
// - options are not included
function getPrice(product: Product, fId: number = null, joinPrices: { [key: number]: JoinPrice } = null, isOption: boolean, menuId = null) {
	if (UpsellService.isInUpsell(product, menuId)) {
		return product.dp;
	}
	// no menu: default price
	if (!joinPrices) {
		return product.dp
	}
	// in menu; get the fid
	if (!fId) {
		fId = product.finalProducts[0].FinalProductId
	}
	// get price
	if (joinPrices[fId]) {
		return joinPrices[fId].Price
	}
	if (isOption) {
		return product.dp
	} else {
		return 0;
	}
}


function getDisplayItems(order) {
	function makeItem(label, amount) {
		return {
			label,
			amount: {
				currency: order.CurrencyCode,
				value: amount,
			},
		};
	}
	let items = _.map(order.oi,(item) =>
	makeItem(item.qty!=1 ? item.qty + ' x ' + item.product.dn : item.product.dn, itemTotal(item))
	);
	if (+order.ShippingFee) {
		items.push(makeItem('Frais de livraison',order.ShippingFee));
	}
	if (+order.ProcessingFee) {
		items.push(makeItem('Frais de gestion',order.ProcessingFee));
	}
	if (+order.Tip) {
		items.push(makeItem('Pourboire',order.Tip));
	}
	if (+order.Discount) {
		items.push(makeItem('Remise',order.Discount));
	}
	return items;
}

function setClientForOrder(order,client) {
	if (order && order.client === client) {
		return;
	}
	if (client) {
		order.ClientId = client && client.ClientId;
	} else {
		order.ClientId = order.shop.AnonClientId;
	}
	order.client = client;
	order.AddressId = null;
	order.CCid = null;
}

function getOptionCart(cartItem, join_option) {
	// return (cartItem.OptionGroups[join_option.OptionGroupId] || {}).Options;
	return (cartItem.OptionGroups[join_option.index] || {}).Options;
}

function sumWeightAllOptionsTaken(cartItem) {
	let s = _.sumBy(cartItem.product.options, (join_option) => {
		return _.reduce(getOptionCart(cartItem, join_option),
		(acc, option) => {
			return acc + option.qty * option.pId;
		}, 0)
	})
	return s;
}

function removeFromCart(item) {
	// _.remove(factory.cart.oi, item)
	factory.cart.oi.splice(factory.cart.oi.indexOf(item),1);
	DataStore.notifyAngularJs();
	saveCart();
}

function increaseItemQty(cartItem) {
	cartItem.qty = 1 + +cartItem.qty;
	saveCart();
}

function decreaseItemQty(cartItem) {
	cartItem.qty = Math.max(cartItem.qty - 1, 1);
	saveCart();
}

function init() {
	function setClient(cart: Order, client?: Client) {
		if (!cart) {
			return;
		}
		cart.client = client;
		cart.ClientId = client?.ClientId;
	}

	EventBus.$on(EVENTS.clientLogin, (identity: Client) => setClient(factory.cart, identity));
	EventBus.$on(EVENTS.shopChanged, function(shop: Shop) {
		// console.log('just got shop, loading cart');
		loadCartHavingShop(shop);
		setClient(factory.cart, ClientService.client);
	});
	EventBus.$on(EVENTS.requestSaveCart, () => saveCart());
}

function changeCartShop(cart, shop: Shop): Order {
	// console.log('changing cart shop to ',shop.ShopId)
	if (cart.deliveryZone && cart.deliveryZone.ShopId != shop.ShopId) {
		cart.deliveryZone = null;
	}
	if (cart.ShopId == shop.ShopId) {
		// same shop, return it
		setCart(resolveOrder(cart,shop));
	} else if (cart.CarteId == shop.CarteId) {
		// other shop, shared carte: keep content, revalidate config ?
		cart.ShopId = shop.ShopId;
		setCart(resolveOrder(cart, shop));
	} else if (cart.GroupId == shop.GroupId) {
		// keep compatible content (based on FinalProduct.MappingProductId
		// cart.oi = [];
		cart.ShopId = shop.ShopId;
		cart.CarteId = shop.CarteId;
		setCart(resolveOrder(cart, shop));
	} else {
		// console.log('cart is not compatible, creating a new one')
		newCart(shop);
	}
	return factory.cart;
}

function loadCartHavingShop(shop) {
	if (!shop) {
		// console.error('no shop');
	}
	if (ShopService.shop !== shop) {
		// console.error('ShopService.shop !== shop',ShopService.shop,shop);
	}
	if (factory.cart && ShopService.shop && factory.cart.ShopId == ShopService.shop.ShopId) {
		// console.log('cart already loaded, same shop');
	}
	if (!localStorage.cart || !localStorage.cart_expires_at) {
		newCart(shop);
	}
	if (moment().isAfter(new Date(localStorage.cart_expires_at))) {
		newCart(shop);
	}
	let cart = JSON.parse(localStorage.cart);
	changeCartShop(cart, shop);
	saveCart();
}

function isRestoMode() {
	return Cookies.get('Table');
}

function setRestoMode(Table) {
	if (!factory.cart) {
		// console.error("no cart");
	}
	let in30minutes = moment().add(30,'minutes').toDate();
	Cookies.set('Table',Table,{expires: in30minutes, });
	if (Table) {
		factory.cart.SaleAreaId = ShopService.SALE_AREAS.RESTAURANT;
		factory.cart.Table = Table;
	}
	saveCart();
}

function deleteRestoMode() {
	Cookies.remove('Table');
}

// @returns item or null if any option or product taken is not available
function refreshPrice(orderItem: CartItem, parentMenuId: number, shop: Shop, isOption: boolean) {
	let item = _.clone(orderItem);
	let pId = item.pId;
	let product = shop.products[pId];
	if (!product || !product.av) {
		let msg = "Le produit " + item.product.dn + " n'est pas disponible";
		if (item.product.ty == PRODUCT_TYPES.Option) {
			msg = "L'option " + item.product.dn + " n'est pas disponible";
		}
		growl.warning(msg);
		return null;
	}
	// pull the product from shop's current carte
	item.product = product;
	let joinPrices = parentMenuId ? shop.menus[parentMenuId].joinPrices : null;
	let price = getPrice(product, item.fId, joinPrices, isOption, parentMenuId);
	item.price = price;
	item.MenuItems = _.clone(orderItem.MenuItems)
	for(let i in item.MenuItems) {
		let orderMenuCategory = _.clone(item.MenuItems[i]);
		let menuItemsInCategory = [];
		for(let j in orderMenuCategory.MenuCategoryItems) {
			let categoryItem = _.clone(orderMenuCategory.MenuCategoryItems[j]);
			categoryItem = refreshPrice(categoryItem, item.pId, shop, false);
			if (!categoryItem) {
				return null;
			}
			menuItemsInCategory.push(categoryItem);
		}
		orderMenuCategory.MenuCategoryItems = menuItemsInCategory;
		item.MenuItems[i] = orderMenuCategory;
	}

	let cartOptionGroups = _.clone(orderItem.OptionGroups);
	for(let j in cartOptionGroups) {
		let optionGroup = _.clone(cartOptionGroups[j]);
		let options = {};
		for(let k in optionGroup.Options) {
			options[k] = refreshPrice(optionGroup.Options[k], parentMenuId, shop, true);
			if (!options[k]) {
				return null;
			}
		}
		optionGroup.Options = options;
		cartOptionGroups[j] = optionGroup;
	}
	item.OptionGroups = cartOptionGroups;

	return item;
}

function convertOrderItem(item, ShopId, parentMenuId, useFreezedPrice, shop, baseQty = 1) {
	return {
		price: item.UnitPrice,
		pId: item.pId,
		fId: item.fId,
		qty: item.qty / baseQty,
		product: {
			virtual: true,
			ShopId,
			dn: item.ProductName,
			dd: shop.products?.[item.pId]?.dd,
			imt: shop.products?.[item.pId]?.imt,
			ims: shop.products?.[item.pId]?.ims,
			// dp:
			ty: item.ProductType,
			id: item.pId,
		},
		MenuItems: _(item.order_menu_items)
			.groupBy('pivot.MenuCategoryId')
			.map((menu_items, MenuCategoryId) => ({
				MenuCategoryId,
				DefaultName: menu_items[0].DefaultName,
				MenuCategoryItems: menu_items.map((item) => convertOrderItem(item, ShopId, item.pId, useFreezedPrice, shop, item.qty)),
			})).value(),
		OptionGroups: _(item.order_item_options)
			.groupBy('pivot.OptionGroupId')
			.map((options, option_group_id) => ({
				OptionGroupId: option_group_id,
				Options: _.map(options, (option) => convertOrderItem(option, ShopId, parentMenuId, useFreezedPrice, shop, item.qty)),
			})).value(),
	};
}

function convertCartItem(orderItem, ShopId, parentMenuId, shop) {
	let pId, price, product;
	let FinalProducts = {[ShopId]:shop.finalProducts};
	let Products = {[ShopId]:shop.products};
	let Menus = {[ShopId]:shop.menus};
	let OptionGroups = {[ShopId]:shop.optionGroups};

	let finalProduct = _.find(FinalProducts[ShopId], {FinalProductId: orderItem.fId })
	if (!finalProduct && orderItem.dn && shop.info.shareProductName) {
		let product = _.find(Products[ShopId], { dn: orderItem.dn })
		finalProduct = product?.finalProducts[0];
	}
	if (!finalProduct) {
		return null;
	}
	product = Products[ShopId][finalProduct.ProductId]
	if (parentMenuId) {
		// need to get price from containing item
		let joinPrices = Menus[ShopId][parentMenuId].joinPrices
		if (joinPrices[finalProduct.FinalProductId]) {
			price = joinPrices[finalProduct.FinalProductId].Price;
		} else {
			// les produits sont inclus dans le prix du menu, mais pas les options
			if (product.ty == 4) {
				price = product.dp;
			} else {
				price = 0;
			}
		}
		// price = _.get(joinPrices[finalProduct.FinalProductId], 'Price', product.dp);
		orderItem.joinPrices = joinPrices
	}
	else {
		price = product.dp
	}

	_.assign(orderItem, {
		price: price,
		pId: finalProduct.ProductId,
		fId: finalProduct.FinalProductId,
		product: product,
	})

	// convert menuItems
	orderItem.MenuItems = _.map(orderItem.MenuItems, (menu_items) => {
		for (var i in menu_items.MenuCategoryItems) {
			menu_items.MenuCategoryItems[i] = convertCartItem(menu_items.MenuCategoryItems[i], ShopId, orderItem.pId, shop)
		}
		return menu_items;
	})

	// convert item options
	orderItem.OptionGroups = _.map(orderItem.OptionGroups, (options) => {
		for (var i in options.Options) {
			options.Options[i] = convertCartItem(options.Options[i], ShopId, parentMenuId, shop)
		}
		return options
	})
	return orderItem
}

function backendToCart(order) {
	// use freezedPrice if order has been paid
	var useFreezedPrice = (order.OrderState >= 0);
	// if its an order, convert
	// if its a Cart (order.CartId), no need to convert, its all stored in the original format
	if (order.OrderId && useFreezedPrice) {
		order.oi = _.map(order.oi, item => convertOrderItem(item, order.CarteId, 0, useFreezedPrice, order.shop))
	} else if (order.CarteId && order.shop) {
		order.oi = _.compact(_.map(order.oi, item => convertCartItem(item, order.CarteId, 0, order.shop)))
	} else {
		growl.warning('Erreur de récupération du panier')
	}
	return order;
}

function emptyCart(keepRestoMode = false) {
	let Table = isRestoMode();
	deleteRestoMode();
	newCart(ShopService.shop);
	if (keepRestoMode && Table) {
		setRestoMode(Table);
	}
	saveCart();
}

let detailedOrders = {};
function getDetails(OrderId, forClient = false, force = false) {
	if (force || !detailedOrders[OrderId]) {
		// client-order by default; even a not logged-in client can view anonymous order details if in-session
		let url = base_url + '/admin/orders/client-order?OrderId='+OrderId;
		if (UserService.user && !forClient) {
			url = base_url + '/admin/orders/shop-order?OrderId='+OrderId;
		}
		let promise = DataStore.get(url, "Impossible d'obtenir les détails de la commande")
		.then((data) => {
			data.order.client = DataStore.normalizeClientData(data.order.client);
			return DataStore.getShopInfo(data.order.ShopId, data.order.CarteId)
			.then(shop => resolveOrder(data.order, shop));
		})
		.then((order) => {
			detailedOrders[OrderId] = promise;
			return order;
		});
		return promise;
	}
	return detailedOrders[OrderId];
}

function resolveOrder(order, shop) {
	order.CarteId = order.CarteId || order.ShopId;
	order.shop = shop;
	if (order.OrderState < 0) { // not paid yet: apply current shop currency
		order.Currency = order.shop.Currency;
		order.CurrencyCode = order.shop.CurrencyCode;
	}
	return backendToCart(order)
}

function newCart(shop: Shop): void {
	setCart({
		isNew: true,
		shop: shop,
		GroupId: shop.GroupId,
		ShopId: shop.ShopId,
		CarteId: shop.CarteId,
		oi: [],
		Table: '',
		SaleModeId: ShopService.SALE_MODES.CLIENT,
		SaleAreaId: null,
		OrderInfo: '',
		Comment: '',
		OrderState: -2, // newOrder not finalized yet, can still be modified
		Currency: shop.Currency,
		CurrencyCode: shop.CurrencyCode,
		paymentRequest: {
			cardPayments: [], 	// {CCid, Amount}
			comoPayments: [],
			fidelitePayments: [],// {cardno, Amount}
			edenredPayments: [],
		},
		ClientId: null,
		AddressId: null,
		Total: 0,
		Subtotal: 0,
		Remain: 0,
		isAtLanding: false,
		landingShown: false,
		landingDone: false,
		deliveryZone: null,
		PickupTimeDate: null,
		PaymentAmount: null,
		paymentSuccess: false,
		client: null,
		address: null,
		info2: {
			Nom: '',
			Mobile: '',
			FirstName: '',
			LastName: '',
			Commentaire: '',
			Company: '',
			cutlery: shop.info.cutlery ? true : false,
			cart_created_at: new Date(),
		},
		from_getresto: false,
	});
	// console.log('new cart')
	saveCart();
	if (shop.info.salon.active) {
		setRestoMode(1);
	}
}

function setCart(cart: Order) {
	factory.cart = cart;
	EventBus.$emit(EVENTS.cartChanged,factory.cart);
}

function orderToJson(order) {
	let json = _.omit(order, 'client', 'shop', 'card', 'address','promo_code');
	json.client_timezone = moment().format('Z');
	json.promo_code_id = order.promo_code && order.promo_code.id;
	json.oi = _.clone(json.oi);
	for (let i in json.oi) {
		let item = json.oi[i] = _.clone(json.oi[i])
		delete item.parent;
		delete item.product;
		delete item.childs;
		clearProductFromOptionGroupsAndRemoveEmptyOptions(item);
		clearProdFromMenuItems(item);
	}
	return json;
}

function clearProdFromMenuItems(item) {
	item.MenuItems = _.clone(item.MenuItems)
	for (let i in item.MenuItems) {
		let category = item.MenuItems[i] = _.clone(item.MenuItems[i])
		category.MenuCategoryItems = _.clone(category.MenuCategoryItems)
		for (let j in category.MenuCategoryItems) {
			let compo = category.MenuCategoryItems[j] = _.clone(category.MenuCategoryItems[j])
			delete compo.parent;
			delete compo.product;
			delete compo.joinPrices;
			clearProductFromOptionGroupsAndRemoveEmptyOptions(compo);
		}
	}
}

function clearProductFromOptionGroupsAndRemoveEmptyOptions(item) {
	let OptionGroups = []
	for (let i in item.OptionGroups) {
		let group = _.clone(item.OptionGroups[i])
		delete group.optionGroup;
		let Options = {};
		for (let j in group.Options) {
			let option = _.clone(group.Options[j]);
			if (option.qty == 0) {
				continue;
			}
			delete option.product;
			Options[j] = option;
		}
		group.Options = Options;
		OptionGroups.push(group);
	}
	item.OptionGroups = OptionGroups;
}

let saving = false;
function saveCart() {
	if (saving) {
		return;
	}
	saving = true;
	let order = factory.cart
	delete order.isNew;

	if (order.SaleAreaId != ShopService.SALE_AREAS.TICKET) {
		order.Subtotal = cartTotal(order.oi);
	} else {
		// order.Subtotal already defined, dont change it
	}
	OrderCalc.recalcFees(order);

	let payload = orderToJson(order);
	// store address
	payload.address = order.address;
	localStorage.cart = JSON.stringify(payload);
	localStorage.cart_expires_at = moment().add(30,'minutes').toDate();

	saving = false;
}

function itemToCartItem({product, ...item }) {
	// these are needed to handle upsell state
	if (UpsellService.cartMenu?.pId == product.id) {
		return UpsellService.cartMenu;
	}
	if (UpsellService.from_cartItem?.id == product.id) {
		return UpsellService.from_cartItem;
	}
	// let fn = create ? _.assign : _.defaults;
	let cartItem = _.defaults({
		OptionGroups: [],
		MenuItems: [],
	},
	item, {
		qty: 1,
		price: product.dp,
		fId: _.get(product, 'finalProducts[0].FinalProductId'),
		pId: product.id,
		product: _.clone(product),
		dn: product.dn,
	})
	cartItem.product.options = _.cloneDeep(cartItem.product.options)
	return cartItem;
}

function isCartItem(item) {
	return item.OptionGroups && item.dn;
}
function getUpselledItemName(item: CartItem) {
	return item.MenuItems[0].MenuCategoryItems[0].product.dn + ' + ' + item.product.dn;
}

// the only required field of cartItem is { product: },
// which is removed after adding it
function addToCart(cart, item, key = undefined) {
	var order = null;
	if (cart.oi) {
		order = cart;
		cart = cart.oi;
		if (order.OrderState != factory.ORDER_STATES.STATE_MODIFIABLE && order.OrderState != factory.ORDER_STATES.STATE_VALIDATED_UNCONFIRMED) {
			growl.error("Ce panier ne peut plus être modifié");
			return;
		}
	}
	if (!item.product.av) {
		growl.error(`L'article ${item.product.dn} n'est pas disponible`);
		return;
	}
	let cartItem = isCartItem(item) ? item : itemToCartItem(item);
	// delete cartItem.product
	var existing = factory.getExistingItem(cart, cartItem);

	if (existing) {
		existing.qty += cartItem.qty
	}
	else {
		if (key) {
			if (_.isArray(cart)) {
				cart.splice(key,0,cartItem);
			} else {
				cart[key] = cartItem;
			}
		} else {
			cart.push(cartItem);
		}
	}
	if (order) {
		// add content inside notification when add to cart
		let notifAddCart = "";
		let dn = item.product.dn;
		if (UpsellService.cartMenu == cartItem) {
			dn = getUpselledItemName(item);
		}
		if (item.product.imt) {
			notifAddCart =
			`<div class="flex-start-center">
			<img class="img-fit radius-4 mr-10" src="${base_img}${item.product.ShopId}/${item.product.imt}" width="36px" height="36px">
			<div>
			<div class="display-5 text-bold">Ajouté au panier</div>
			<div class="display-6">
				${cartItem.qty != 1 ? cartItem.qty + 'x' : ''}
				${dn}
				</div>
				</div>
				</div>`
			} else {
				notifAddCart =
			`<div class="flex-start-center">
			<i class="fie-icon_takeaway2 mr-10 fsize-35 no-line-height"></i>
			<div>
			<div class="display-5 text-bold">Ajouté au panier</div>
			<div class="display-6">
				${cartItem.qty != 1 ? cartItem.qty + 'x' : ''}
				${dn}
			</div>
			</div>
			</div>`
		}
		growl.neutral(notifAddCart);

		if (cartItem.tid && UrlService.params.tid == cartItem.tid) {
			// notifyNG ?
			setTimeout(()=>UrlService.go({name:'carte', params:{ ShopId: order.ShopId, tid: cartItem.parent.tid }}));
		} else if (UrlService.params.pid && UrlService.params.pid == UpsellService.from_cartItem?.pId) {
			if (UpsellService.from_cartItem?.parent.tid) {
				setTimeout(()=>{
					UrlService.go({name:'carte', params:{ ShopId: order.ShopId, tid: UpsellService.from_cartItem.parent.tid }})
					UpsellService.reset();
				});
			} else {
				history.back();
			}
		}
		saveCart();
	}
}

function isMenu(cartItem) {
	return cartItem.product.ty == 2;
}
function isProduct(cartItem) {
	return cartItem.product.ty == 3;
}


function checkOrder(cartItem) {
	let can = canOrder(cartItem);
	if (!can) {
		let missing = OptionCategoryService.getMissingRequiredItems(cartItem);
		let msg = "Il manque <ul>";
		for(let i in missing.MenuCategoryItems) {
			let requirement = missing.MenuCategoryItems[i];
			let missingQty = requirement.min - requirement.taken;
			msg += `<li>${missingQty} ${requirement.category.DefaultName}${missingQty>1?'s':''}</li>`;
		}
		for(let j in missing.OptionGroups) {
			let requirement = missing.OptionGroups[j];
			let missingQty = requirement.min - requirement.taken;
			msg += `<li>${missingQty} ${requirement.optionGroup.optionGroup.name}${missingQty>1?'s':''}</li>`;
		}
		msg += "</ul>";
		growl.error(msg);
	}
	return can;
}

// returns true if all required MenuCategoryItems and option choices have been taken
// althought we're not checking if require MenuCategoryItems's options have been taken
function canOrder(cartItem) {
	if (isMenu(cartItem)) {
		if (cartItem.MenuItems.length < cartItem.product.categories.length) {
			return false;
		}
		for (let i in cartItem.MenuItems) {
			let menuItem = cartItem.MenuItems[i];
			let min = menuItem.MinChoicesNumber;
			let takenCompos = _.sumBy(menuItem.MenuCategoryItems, 'qty')
			if (takenCompos < min) {
				return false;
			}
		}
	}
	if (isProduct(cartItem)) {
		if (_.size(cartItem.OptionGroups) < cartItem.product.options.length) {
			return false;
		}
		for (let i in cartItem.OptionGroups) {
			let optionGroup = cartItem.OptionGroups[i];
			let min = optionGroup.minChoices;
			let takenChoices = _.sumBy(_.values(optionGroup.Options), 'qty');
			if (takenChoices < min) {
				return false;
			}
		}
	}
	return true;
}



// check if only the qty differs between cartItem and an existing item in the list
function getExistingItem(list, cartItem) {
	if (cartItem.product.ty != PRODUCT_TYPES.Product && cartItem.product.ty != PRODUCT_TYPES.Option) {
		return null;
	}
	if (!_.isEmpty(cartItem.product.options)) {
		return null;
	}
	var existingItem = _.find(list, {
		fId: cartItem.fId
	})
	return existingItem;
}

function itemTotal(cartItem, baseQty = 1) {
	var optionsTotal = _.sumBy(_.toArray(cartItem.OptionGroups), function(OptionGroup) {
		return _.sumBy(_.toArray(OptionGroup.Options), function(Option) {
			return Option.qty * Option.price
		})
	})

	var menuItemsTotal = _.sumBy(cartItem.MenuItems, categoryTotal)
	return baseQty * cartItem.qty * (+cartItem.price + optionsTotal + menuItemsTotal)
}

function categoryTotal(category) {
	return _.sumBy(category.MenuCategoryItems, itemTotal)
}

function cartTotal(cart: Order['oi'] = factory.cart && factory.cart.oi) {
	return _.sumBy(cart, factory.itemTotal)
}
